module.exports = __webpack_public_path__ + "static/1-7d5f17b646257369cffec3b873ae544d.jpg";